export enum ESolarSimLocalStorage {
  ESTIMATOR_DETAILS_ADVANCED = "ESTIMATOR_DETAILS_ADVANCED",
  ESTIMATOR_DETAILS_SIMPLIFIED = "ESTIMATOR_DETAILS_SIMPLIFIED",
  ESTIMATOR_DETAILS_DIRECT = "ESTIMATOR_DETAILS_DIRECT",
  ESTIMATOR_DETAILS_WATER_HEATER = "ESTIMATOR_DETAILS_WATER_HEATER",
}
